import React, { useEffect } from "react";
import AppNavBar from "../components/AppNavBar";
import { useAccountStore } from "../zustand/account";
import { useObjectStore } from "../zustand/objects";
import { Anchor, Container, Stack, Text, Title } from "@mantine/core";
import { getStoryboardChromeTheme, pageLayoutProps } from "../styleFile";
import { CHROME_HEADER_HEIGHT } from "../utils/uiChromeTokens";

const TemplatesPage = () => {
  const { userStatus } = useAccountStore();
  const viewportThemeOverride = useObjectStore((s) => s.viewportThemeOverride);
  const isDark = viewportThemeOverride === "dark";
  const sbTheme = getStoryboardChromeTheme(isDark);

  useEffect(() => {
    if (typeof document === "undefined") return undefined;
    document.body.setAttribute("data-editor-theme", isDark ? "dark" : "light");
    return () => document.body.removeAttribute("data-editor-theme");
  }, [isDark]);

  return (
    <>
      <AppNavBar pageName="Templates" />
      <Container
        {...pageLayoutProps}
        style={{ backgroundColor: sbTheme.mainBg, minHeight: `calc(100vh - ${CHROME_HEADER_HEIGHT}px)` }}
      >
        <Stack gap="sm" maw={640}>
          <Title order={3} c={sbTheme.headlineColor}>
            Templates
          </Title>
          {userStatus === "loggedIn-active" ? (
            <>
              <Text size="xs" c={sbTheme.bodyTextColor}>
                Copy the templates below to use them in your workflow.
              </Text>
              <Text size="xs" c={sbTheme.bodyTextColor}>
                Miro co-design template{" "}
                <Anchor href="https://miro.com/app/board/uXjVMiH4pIk=/?share_link_id=13824265482" target="_blank" rel="noreferrer">
                  here
                </Anchor>
                .
              </Text>
              <Text size="xs" c={sbTheme.bodyTextColor}>
                Google Slides pitch template{" "}
                <Anchor href="https://docs.google.com/presentation/d/1cR0YpP11YFtBUXnLc39R0bDYK7BOl89LVAqD2HVKBeM/edit?usp=sharing" target="_blank" rel="noreferrer">
                  here
                </Anchor>
                .
              </Text>
            </>
          ) : (
            <Text size="sm" c={sbTheme.mutedTextColor}>
              Upgrade for Miro and Google Slides templates.
            </Text>
          )}
        </Stack>
      </Container>
    </>
  );
};

export default TemplatesPage;
